import MasterPileData from 'Data/master-data-piles.json'
import { useSearchParams } from 'react-router-dom'
import { useShippingStore } from 'Store/Shipping'
import { shallow } from 'zustand/shallow'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'

const RANDOM_QRCODE_DATAS = [...Array(8)].map(() => ({
  ...MasterPileData[Math.floor(Math.random() * MasterPileData.length)],
  qrCodeData:
    Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
}))

const ViewModel = () => {
  const [searchParams] = useSearchParams()
  const shippingId = searchParams.get('shippingId')
  const [isLoading, setIsLoading] = useState(false)
  const { data, getData, clearState } = useShippingStore(
    state => ({
      data: state.inventories,
      getData: state.getInventories,
      clearState: state.clearState,
    }),
    shallow
  )

  const fetchData = () => {
    if (!shippingId) {
      toast.error('Shipping ID is required')
    } else {
      setIsLoading(true)
      getData(parseInt(shippingId)).then(({ success, data }) => {
        if (!success) {
          toast.error(data)
        } else {
          setIsLoading(false)
        }
      })
    }
  }

  useEffect(() => {
    fetchData()

    return () => {
      clearState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingId])

  return {
    isLoading,
    shippingId,
    data,
    RANDOM_QRCODE_DATAS,
  }
}

export default ViewModel
